import { Component, Injector } from '@angular/core';
import { BaseControlValueAccessor } from '../../../core/base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

const MAX_NAME_COMPANY_LENGTH = 32;

@Component({
    selector: 'jhi-nom-entreprise',
    templateUrl: './nom-entreprise.component.html',
    styleUrls: ['./nom-entreprise.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: NomEntrepriseComponent,
            multi: true
        }
    ]
})
export class NomEntrepriseComponent extends BaseControlValueAccessor {
    showLengthWarningForCompanyName = false;
    maxCompanyNameLength = MAX_NAME_COMPANY_LENGTH;
    actualNameCompanyLength = 0;

    nomEntreprise: string;

    constructor(injector: Injector) {
        super(injector);
    }

    protected modelValueChanged(nomEntreprise: any): void {
        this.nomEntreprise = nomEntreprise;
        this.checkLengthForCompanyName(this.nomEntreprise);
    }

    private checkLengthForCompanyName(value: string) {
        if (value) {
            this.actualNameCompanyLength = value.length;
            this.showLengthWarningForCompanyName =
                value.length > this.maxCompanyNameLength;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/identite-organisme/nom-entreprise/nom-entreprise.component.ts